import { GhostButton } from '../shared/GhostButton'

type FeedKind = 'INSIGHT' | 'ALERT' | 'INTEL'

interface FeedItemData {
  kind: FeedKind
  text: string
  cta: string
}

interface FeedItemProps {
  kind: FeedKind
  text: string
  cta: string
}

function FeedItem({ kind, text, cta }: FeedItemProps) {
  const chipClass =
    kind === 'INSIGHT'
      ? 'text-brand-glow border-brand-glow/30 bg-brand-glow/10'
      : kind === 'ALERT'
        ? 'text-brand-alert border-brand-alert/30 bg-brand-alert/10'
        : 'text-muted border-border-light bg-surface-light'

  return (
    <li className="flex items-start justify-between gap-4 rounded-xl border border-border-light bg-surface-light p-4">
      <div className="flex items-start gap-3">
        <span className={`text-[10px] px-2 py-0.5 rounded border ${chipClass}`}>{kind}</span>
        <div className="text-sm text-ink/90">{text}</div>
      </div>
      <GhostButton>{cta}</GhostButton>
    </li>
  )
}

export function InsightsFeed() {
  const items: FeedItemData[] = [
    {
      kind: 'INSIGHT',
      text: "We've identified 3 new integration partners in your vertical. 'DataViz Pro' looks like a +$2.5k MRR opportunity.",
      cta: 'View Play'
    },
    {
      kind: 'ALERT',
      text: "Your TTM revenue is up, but your 30-day churn has increased by 8%, putting your 'Focus Pick' status at risk.",
      cta: 'See Details'
    },
    {
      kind: 'INTEL',
      text: "Your top 3 competitors all just raised their prices for 'Pro' plans by an average of 15%.",
      cta: 'View Report'
    }
  ]

  return (
    <section id="feed" className="rounded-2xl border border-border bg-surface p-6 shadow-[0_12px_50px_rgba(8,13,24,0.6)]">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-[11px] uppercase tracking-[0.24em] text-muted">Segment intel</p>
          <h3 className="mt-1 text-lg font-semibold text-ink">Signals to brief your investors</h3>
        </div>
        <span className="text-[11px] px-2 py-0.5 rounded border border-border-light bg-surface-light text-muted">Monitoring 24/7</span>
      </div>
      <ul className="mt-5 space-y-3">
        {items.map((item, index) => (
          <FeedItem key={`${item.kind}-${index}`} kind={item.kind} text={item.text} cta={item.cta} />
        ))}
      </ul>
    </section>
  )
}
